import { render, staticRenderFns } from "./KdsColumn.vue?vue&type=template&id=558e3eb6&scoped=true"
import script from "./KdsColumn.vue?vue&type=script&lang=js"
export * from "./KdsColumn.vue?vue&type=script&lang=js"
import style0 from "./KdsColumn.vue?vue&type=style&index=0&id=558e3eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558e3eb6",
  null
  
)

export default component.exports